module.exports = __webpack_public_path__ + "img/icon5.145f0c2a.svg";